import { useCurrentCoachId } from "@/modules/core/store/useCurrentSpaceManagerStore"
import { RouteNavigate, type RoutePath, useBaseNavigate } from "@modules/navigation/hooks/useBaseNavigate"
import { Path } from "@modules/navigation/routes"
import { type NavigateOptions } from "react-router"

export const useCoachNavigate = () => {
  const coachId = useCurrentCoachId()
  const navigate = useBaseNavigate()

  return (path: RoutePath, options: NavigateOptions & { newCoachId?: string } = {}) => {
    const { newCoachId, ...navigateOption } = options
    navigate(path, () => getCoachPath(path, { newCoachId: newCoachId ?? coachId }), navigateOption)
  }
}

export const getCoachPath = (path: Omit<RoutePath, RouteNavigate.Back>, options?: { newCoachId?: string | null }) => {
  const coachId = options?.newCoachId

  if (coachId) {
    if (path === RouteNavigate.Root) {
      return Path.Coach.Root(coachId)
    } else {
      return `${Path.Coach.Root(coachId)}/${String(path)}`
    }
  }
  return ""
}
